import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || '/';
const api = axios.create({ baseURL });

api.defaults.headers.get['Cache-Control'] = 'no-cache';
api.defaults.cache = 'no-store';

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) prom.reject(error);
        else prom.resolve(token);
    });
    failedQueue = [];
};

api.interceptors.response.use(
    response => response,
    async error => {
        const originalReq = error.config;
        if (error.response?.status === 401 && !originalReq._retry) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(token => {
                    originalReq.headers.Authorization = `Bearer ${token}`;
                    return api(originalReq);
                }).catch(err => Promise.reject(err));
            }
            originalReq._retry = true;
            isRefreshing = true;

            try {
                // Assumes backend /api/refresh uses stored refresh logic or same token
                const refreshRes = await api.post('/api/refresh');
                const newToken = refreshRes.data.token;
                localStorage.setItem('token', newToken);
                originalReq.headers.Authorization = `Bearer ${newToken}`;
                processQueue(null, newToken);
                return api(originalReq);
            } catch (refreshError) {
                processQueue(refreshError, null);
                localStorage.removeItem('token');
                window.location.href = '/login';
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);

export default api;
